// IMPORTANT: Please note that you have to copy and paste
// this file to production manually because this file will not get uploaded to Shopify prod.

// CODE for Runway Collections Dropdown in the Header
const collection_category = "Runway".toLowerCase();
const projects_url = "/pages/project-list?cat=" + collection_category;

async function fetchProducts(url, category) {
  const response = await fetch(url);
  const html = await response.text();
  // Convert the HTML string into a document object
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  let projectList = doc.querySelector("#allProjectCategories");
  projectList = JSON.parse(projectList.value);
  const filterProjectList = projectList.filter(
    (project) => project.category.toLowerCase() === category
  );
  const list = filterProjectList
    .map((project) => `<li class="nav-link"><a href=${project.url}>${project.title}</a></li>`)
    .join("");
  document.querySelector("ul.nav-link__dropdown").innerHTML = list;
}
if (collection_category && document.querySelector("ul.nav-link__dropdown")) {
  fetchProducts(projects_url, collection_category);
}

// Code for Subscription Form in the Footer
function subscriptionSubmit(event) {
  event.preventDefault();
  const email = document.getElementById("k_id_email").value;
  const settings = {
    async: true,
    crossDomain: true,
    url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache",
    },
    data: {
      g: "XrMt3c",
      $fields: "email",
      email: email,
      $source: "Custom Forms",
    },
  };

  $.ajax(settings).done(function (response) {
    if (response.data.is_subscribed) {
      document.getElementById("k_id_email").value = "";
      document.getElementById("form-response").textContent =
        "Thank you for signing up. We look forward to share our journey with you.";
      setTimeout(
        () => (document.getElementById("form-response").textContent = ""),
        10000
      );
    }
  });
}


window.addEventListener('DOMContentLoaded',function () {
  const frontpageCollectionSections = document.querySelectorAll('.js-collectionImages')
  const fullWidthImageSections = document.querySelectorAll('.js-fullWidthImage')
  const imageWithTextSections = document.querySelectorAll('.js-imageWithText')

  if (frontpageCollectionSections?.length > 0) initFrontpageCollectionSections(frontpageCollectionSections)
  if (fullWidthImageSections?.length > 0) initFullWidthImageSections(fullWidthImageSections)
  if (imageWithTextSections?.length > 0) initImageWithTextSections(imageWithTextSections)
});




function initFrontpageCollectionSections (sections) {
  sections.forEach(section => {
    const sectionId = section.dataset.sectionId
    const imageWrap = document.getElementById(sectionId)
    const verticalImgs = imageWrap?.querySelectorAll('.image-wrapper--vertical')
    const horizontalImgs = imageWrap?.querySelectorAll('.image-wrapper--horizontal')

    if (verticalImgs?.length > 1 || horizontalImgs?.length > 1) {
      const intervalTime = Number(imageWrap?.getAttribute('data-interval')) || 2500
      const alternateTransition = imageWrap?.getAttribute('data-alternate') === 'true'

      let currentVertical = 1
      let currentHorizontal = 1
      let lastVertical = false
      let lastHorizontal = false

      if (verticalImgs?.length > 1) {
      setInterval(() => {
        verticalImgs.forEach(img => {
          const dataIndex = img.getAttribute('data-index')
          const dataLastItem = img.getAttribute('data-last-item') !== null
          if (currentVertical === Number(dataIndex)) {
            img.classList.add('active')
            img.classList.remove('inactive')
            lastVertical = dataLastItem
          } else {
            img.classList.remove('active')
            img.classList.add('inactive')
          }
        })
        currentVertical = lastVertical ? 0 : currentVertical + 1
      }, intervalTime)
      }

      if (horizontalImgs?.length > 1) {
      setTimeout(() => {
        setInterval(() => {
          horizontalImgs.forEach(img => {
            const dataIndex = img.getAttribute('data-index')
            const dataLastItem = img.getAttribute('data-last-item') !== null
            if (currentHorizontal === Number(dataIndex)) {
              img.classList.add('active')
              img.classList.remove('inactive')
              lastHorizontal = dataLastItem
            } else {
              img.classList.remove('active')
              img.classList.add('inactive')
            }
          })
          currentHorizontal = lastHorizontal ? 0 : currentHorizontal + 1
        }, intervalTime)
      }, alternateTransition ? intervalTime / 2 : 0)
      }
    }
  })
}

function initFullWidthImageSections (sections) {
  sections.forEach(section => {
    const sectionId = section.dataset.sectionId

    let fullWidthImageOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25,
    };

    let fullWidthImageOptionsCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.querySelector('.header .inner-container').classList.add('header-white');
        } else {
          document.querySelector('.header .inner-container').classList.remove('header-white');
        }
      });
    };

    let fullWidthImageObserver = new IntersectionObserver(fullWidthImageOptionsCallback, fullWidthImageOptions);

    if (section) {
      fullWidthImageObserver.observe(section);
    }


    const imageWrap = document.getElementById(sectionId)
    const fullWidthImages = imageWrap?.querySelectorAll('.image-wrapper--full-width')

    if (fullWidthImages?.length > 1) {
      const intervalTime = Number(imageWrap?.getAttribute('data-interval')) || 2500

      let currentImg = 1
      let lastImg = false

      setInterval(() => {
        fullWidthImages.forEach(img => {
          const dataIndex = img.getAttribute('data-index')
          const dataLastItem = img.getAttribute('data-last-item') !== null
          if (currentImg === Number(dataIndex)) {
            img.classList.add('active')
            img.classList.remove('inactive')
            lastImg = dataLastItem
          } else {
            img.classList.remove('active')
            img.classList.add('inactive')
          }
        })
        currentImg = lastImg ? 0 : currentImg + 1

      }, intervalTime)
    }
  })
}

function initImageWithTextSections (sections) {
  sections.forEach(section => {
    const sectionId = section.dataset.sectionId
    const imageWrap = document.getElementById(sectionId)
    const fullWidthImages = imageWrap?.querySelectorAll('.image-wrapper--image-with-text')

    const productLinks = imageWrap?.querySelectorAll('.js-productLink')


    if (fullWidthImages?.length > 1) {
      const intervalTime = Number(imageWrap?.getAttribute('data-interval')) || 2500

      let currentImg = 1
      let lastImg = false

      setInterval(() => {
        fullWidthImages.forEach(img => {
          const dataIndex = img.getAttribute('data-index')
          const dataLastItem = img.getAttribute('data-last-item') !== null

          if (currentImg === Number(dataIndex)) {
            img.classList.add('active')
            img.classList.remove('inactive')
            lastImg = dataLastItem
          } else {
            img.classList.remove('active')
            img.classList.add('inactive')
          }
        })


        productLinks.forEach(link => {
          link.classList.remove('product-link--active')
        })
        productLinks[currentImg].classList.add('product-link--active')

        currentImg = lastImg ? 0 : currentImg + 1

      }, intervalTime)
    }
  })
}
